/**
 * Utility for conditionally joining class names
 * Lightweight alternative to clsx/classnames
 */
export function cx(
  ...classes: Array<string | undefined | null | false | 0>
): string {
  return classes.filter(Boolean).join(" ");
}
